import React from 'react';
import StoreModal from '../../../../components/modals/StoreModal';
import { transactionSuccess } from '../../../../libs/data/modalContent';
import { PaymentResultType } from '../../../../libs/enums/paymentResultType';

const SuccessModal = ({ onClick }) => {
  return (
    <StoreModal
      content={transactionSuccess}
      type={PaymentResultType.SUCCESS}
      onClick={onClick}
    />
  );
};

export default SuccessModal;
